import { useEffect, useRef, useState } from 'react'

import { Container } from 'components/container'
import { IconFacebook } from 'components/icons/facebook'
import { IconTelegram } from 'components/icons/telegram'
import { IconCopylink } from 'components/icons/copylink'
import { IconShare } from 'components/icons/share'
import { IconClose } from 'components/icons/close'
import { shareUrls } from './utils'
import {
  StyledHeader,
  Logo,
  LogoContainer,
  ObservedPoint,
  ReducedNavHeight,
  Social,
  SocialToggle,
  Confirmation,
  ButtonWrapper,
} from './styled'
import { IconTwitter } from 'components/icons/twitter'
import { AnimatePresence } from 'framer-motion'

let timeout: NodeJS.Timeout

export const Header = () => {
  const pointRef = useRef<HTMLDivElement>(null)
  const [hasScrolled, setHasScrolled] = useState(false)
  const [isShareOpen, setShareOpen] = useState(false)
  const [isConfirmationVisible, setConfirmationVsiible] = useState(false)

  useEffect(() => {
    if (isConfirmationVisible) {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        setConfirmationVsiible(false)
      }, 3000)
    }

    return () => {
      clearTimeout(timeout)
    }
  }, [isConfirmationVisible])

  useEffect(() => {
    const observer = new IntersectionObserver(([point]) => {
      setHasScrolled(!point.isIntersecting)
    })

    if (pointRef.current) {
      observer.observe(pointRef.current)
    }

    return () => observer.disconnect()
  }, [])

  const handleCopy = () => {
    navigator.clipboard.writeText(window.location.href).then(
      () => {
        setConfirmationVsiible(true)
      },
      () => {
        /* clipboard write failed */
      }
    )
  }

  return (
    <>
      <ObservedPoint ref={pointRef} />
      <StyledHeader $hasScrolled={hasScrolled}>
        <Container $fluid>
          <LogoContainer
            title="CurrentTime"
            href="/"
            $isShareOpen={isShareOpen}
          >
            <Logo />
          </LogoContainer>
        </Container>
      </StyledHeader>

      <Social $isShareOpen={isShareOpen}>
        <ul>
          <li>
            <a href={shareUrls.facebook} target="_blank">
              <IconFacebook />
            </a>
          </li>
          <li>
            <a href={shareUrls.twitter} target="_blank">
              <IconTwitter />
            </a>
          </li>
          <li>
            <ButtonWrapper>
              <button onClick={handleCopy}>
                <IconCopylink />
              </button>
              <AnimatePresence>
                {isConfirmationVisible && (
                  <Confirmation
                    initial={{ opacity: 0, translateY: '1rem' }}
                    animate={{ opacity: 1, translateY: '0rem' }}
                    exit={{ opacity: 0, translateY: '1rem' }}
                  >
                    Адрес сайта был скопирован!
                  </Confirmation>
                )}
              </AnimatePresence>
            </ButtonWrapper>
          </li>
        </ul>
        <SocialToggle onClick={() => setShareOpen(v => !v)}>
          {isShareOpen ? <IconClose /> : <IconShare />}
        </SocialToggle>
      </Social>

      {hasScrolled && <ReducedNavHeight />}
    </>
  )
}
